module.exports = __webpack_public_path__ + "img/qna-graphics.81c2ab04.svg";